import { QueryKeyConfig } from './api-helper';

export const countyApiKeyStore = {
  getCounties: (): QueryKeyConfig => ({
    queryKey: [`GET_COUNTIES`],
    route: `/county`,
  }),
};
